import classes from 'components/common/PageContainer/BottomHeaderSection.module.scss';

export const BottomHeaderSection = ({ children }) => {
    return <div className={classes.bottomHeaderSection}>{children}</div>;
};
